<template>
  <div>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="createSuccessModal"
      title="創建成功"
    >
      <div class="modalBody">
        <p>{{ currentData.role_name_ch }}</p>
        <p>平台:{{ cLink }}</p>
        <p>名稱:{{ currentData.name }}</p>
        <p>
          {{ currentData.api_key ? "商戶號" : "編號" }}:{{ currentData.id }}
        </p>
        <p>登入帳號:{{ currentData.username }}</p>
        <p>登入密碼:{{ currentData.l_password }}</p>
        <p>提款密碼:{{ currentData.l_withdraw_password }}</p>
        <p v-if="currentData.api_key">商戶密鑰:{{ currentData.api_key }}</p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="createSuccessModal = false" class="oBtn">關閉</div>
      </div>
    </el-dialog>
    <h2 class="title">創建帳號</h2>
    <el-radio-group v-model="createMethods" style="margin-bottom:15px">
      <el-radio label="customer">商戶</el-radio>
      <el-radio label="subagent">代理</el-radio>
      <el-radio label="agent" v-if="$permission('users.manage.agents.store')"
        >高代</el-radio
      >
    </el-radio-group>
    <el-form :inline="true" :model="createData" class="demo-form-inline">
      <el-form-item label="帳號">
        <el-input
          v-model="createData.username"
          placeholder="請輸入帳號"
        ></el-input>
      </el-form-item>
      <el-form-item label="名稱">
        <el-input v-model="createData.name" placeholder="請輸入名稱"></el-input>
      </el-form-item>
      <el-form-item label="高代ID" v-if="createMethods != 'agent' && agentList">
        <el-select
          v-model="createData.agent_id"
          filterable
          placeholder="請選擇高代ID"
        >
          <el-option
            v-for="agent in agentList"
            :key="agent.user_id"
            :value="agent.user_id"
            :label="agent.user_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="createAcc">確認創建</el-button>
      </el-form-item>
    </el-form>
    <h2 class="title" style="margin-top:30px">綁定一般代理</h2>
    <el-form :inline="true" :model="bindData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-select
          v-model="bindData.customer_id"
          filterable
          placeholder="請選擇商戶號"
          @change="getSubagent"
        >
          <el-option
            v-for="customer in customerList"
            :key="customer.user_id"
            :value="customer.user_id"
            :label="customer.user_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一般代理">
        <el-select
          v-model="bindData.subagent_id"
          filterable
          placeholder="請選擇一般代理"
        >
          <el-option
            v-for="subagent in unbindSubagent"
            :key="subagent.user.id"
            :value="subagent.user.id + '-' + subagent.agent_id"
            :label="subagent.user.id + '-' + subagent.user.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="bind">確認綁定</el-button>
      </el-form-item>
    </el-form>
    <h2 class="title" style="margin-top:30px">解除一般代理</h2>
    <el-form :inline="true" :model="reBindData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-select
          v-model="reBindData.customer_id"
          filterable
          placeholder="請選擇商戶號"
          @change="getBindSubagent"
        >
          <el-option
            v-for="customer in customerList"
            :key="customer.user_id"
            :value="customer.user_id"
            :label="customer.user_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一般代理">
        <el-select
          v-model="reBindData.subagent_id"
          filterable
          placeholder="請選擇一般代理"
        >
          <el-option
            v-for="subagent in bindSubagent"
            :key="subagent.subagent.user.id"
            :value="
              subagent.subagent.user.id + '-' + subagent.subagent.agent_id
            "
            :label="
              subagent.subagent.user.id + '-' + subagent.subagent.user.name
            "
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="removeBind">解除綁定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cLink: process.env.VUE_APP_C_LINK,
      createMethods: "customer",
      createData: {},
      agentList: false,
      currencies: [],
      currentData: {},
      createSuccessModal: false,
      bindData: {},
      unbindSubagent: [],
      reBindData: {},
      bindSubagent: [],
      customerList: []
    };
  },
  methods: {
    removeBind() {
      if (!this.reBindData.customer_id) {
        this.$message.error("請選擇商戶");
        return;
      }
      if (!this.reBindData.subagent_id) {
        this.$message.error("請選擇一般代理");
        return;
      }
      let data = {
        subagent_id: this.reBindData.subagent_id.split("-")[0],
        customer_id: this.reBindData.customer_id,
        agent_id: this.reBindData.subagent_id.split("-")[1]
      };
      this.$http
        .delete(`/back/customers/unbind`, { params: data })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.reBindData = {};
          }
        });
    },
    getBindSubagent() {
      // if (
      //   this.reBindData.customer_id == "" ||
      //   this.reBindData.customer_id.length != 5
      // )
      //   return;
      this.$http
        .get(`/back/customers/${this.reBindData.customer_id}/bind`)
        .then(res => {
          this.bindSubagent = res.data.data;
        });
    },
    bind() {
      let data = JSON.parse(JSON.stringify(this.bindData));
      if (Object.keys(data).length != 2) {
        this.$message.error("請輸入完整資訊");
        return;
      }
      let sendData = {
        customer_id: data.customer_id,
        subagent_id: data.subagent_id.split("-")[0],
        agent_id: data.subagent_id.split("-")[1]
      };
      this.$http.post(`/back/customers/bind`, sendData).then(res => {
        if (res.data.code == 0) {
          this.$message.success("成功");
          this.bindData = {};
        }
      });
    },
    getSubagent() {
      // console.log("ss");
      // if (
      //   this.bindData.customer_id == "" ||
      //   this.bindData.customer_id.length != 5
      // )
      //   return;
      this.$http
        .get(`/back/customers/${this.bindData.customer_id}/unbind`)
        .then(res => {
          this.unbindSubagent = res.data.data;
        });
    },
    location() {
      return location.origin;
    },
    createAcc() {
      let api;
      let data = {};
      let haveAgent = true;
      if (!this.createData.username) {
        this.$message.error("請輸入帳號");
        return;
      }
      if (!this.createData.name) {
        this.$message.error("請輸入名稱");
        return;
      }
      if (this.createMethods == "customer") {
        api = "/back/users";
        data.name = this.createData.name;
        data.username = this.createData.username;
        data.email = this.createData.email;
        data.agent_id = this.createData.agent_id;
        data.phone = this.createData.phone;
        data.role_name = "customer";
        data.region = "TW";
      } else if (this.createMethods == "subagent") {
        api = "/back/users";
        data.name = this.createData.name;
        data.username = this.createData.username;
        data.agent_id = this.createData.agent_id;
        // data.customer_id = this.createData.customer;
        data.email = this.createData.email;
        data.phone = this.createData.phone;
        data.role_name = "subagent";
      } else {
        data.name = this.createData.name;
        data.username = this.createData.username;
        data.email = this.createData.email;
        data.phone = this.createData.phone;
        data.system_rate = 0;
        // data.system_rate = this.createData.system_rate;
        // data.system_add = this.createData.system_add;
        // data.system_add = this.createData.system_add;
        if (this.currency) {
          data.currency = this.currency;
        }
        data.role_name = "agent";
        api = "/back/agents";
      }
      // 查詢高代ID
      if (data.agent_id) {
        haveAgent = false;
        this.agentList.forEach(e => {
          if (e.user_id == data.agent_id) {
            haveAgent = true;
          }
        });
      }
      if (!haveAgent) {
        this.$message.error("請輸入正確高代ID");
        return;
      }
      Object.keys(data).forEach(e => {
        if (data[e] === "") {
          delete data[e];
        }
      });
      this.$http.post(`${api}`, data).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.user) {
            this.currentData = res.data.data.user;
          } else {
            this.currentData = res.data.data;
          }
          if (data.role_name == "customer") {
            this.$http.get(`/back/customers/${res.data.data.id}`).then(res => {
              if (res.data.code == 0) {
                this.currentData.api_key = res.data.data.api_key;
                this.createSuccessModal = true;
              }
            });
          } else {
            this.createSuccessModal = true;
          }
        }
      });
    },
    getAgentList() {
      this.$http.get(`/back/agents`).then(res => {
        if (res.data.code == 0) {
          this.agentList = res.data.data;
        }
      });
    },
    getCurrency() {
      this.$http.get("/back/currency").then(res => {
        if (res.data.code == 0) {
          this.currencies = res.data.data;
        }
      });
    }
  },
  created() {
    this.$http.get(`/back/customers`).then(res => {
      if (res.data.code == 0) {
        this.customerList = res.data.data;
      }
    });
    setTimeout(() => {
      if (this.$permission("users.manage.agents.index")) {
        this.getAgentList();
      }
    }, 3000);
    this.getCurrency();
  }
};
</script>
